import { Box, FormHelperText, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import logo from "assets/logos/white-logo-2.png";
import background from "assets/mesh/background6.png";

const PlanDetailsForInstagramOnboarding = () => {
  const styles = {
    notifications: {
      backgroundImage: `url(${background})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      px: 2,
      py: 0.5,
      borderRadius: 4,
    },
  };

  return (
    <Box>
      <Typography variant="h2" textAlign="center" gutterBottom>
        <strong>
          Bento's <br />
          Virtual Assistant
        </strong>
      </Typography>

      <Typography
        textAlign="center"
        sx={{ fontSize: 16, color: grey[800] }}
        gutterBottom
      >
        <strong>300+ pitches and follow-ups. Zero effort.</strong>
      </Typography>
      <Typography textAlign="center" sx={{ px: 3, color: grey[800] }}>
        Bento's AI find the right brands and handles the outreach for you
      </Typography>

      <Grid item xs={12} container justifyContent="center" sx={{ mt: 3 }}>
        <Grid container alignItems="center" sx={{ maxWidth: 400 }} gap={1}>
          <Grid item xs={1} container alignItems="center">
            <Typography sx={{ fontSize: 25 }}>🔔</Typography>
          </Grid>
          <Grid
            item
            xs
            container
            sx={styles.notifications}
            alignItems="center"
            gap={2}
          >
            <Grid item>
              <Box
                component="img"
                src={logo}
                sx={{ width: 50, borderRadius: 2, mt: 1 }}
              />
            </Grid>

            <Grid item xs>
              <Grid container justifyContent="space-between">
                <Typography sx={{ fontSize: 12 }}>
                  <strong>Bento</strong>
                  <br />
                </Typography>
                <FormHelperText sx={{ fontSize: 8, color: grey[800] }}>
                  1m ago
                </FormHelperText>
              </Grid>
              <Typography sx={{ fontSize: 12, pr: 2 }}>
                Your virtual assistant pitched to 45 beauty brands.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PlanDetailsForInstagramOnboarding;
